<template>
    <div class="page-wrap">
        <div style="width:100%" class="loginwrap">
            <el-row :gutter="20" type="flex" justify="space-between" align="bottom">
                <el-col :span="24">
                    <h2>Forgot your password?</h2>
                </el-col>
            </el-row>
            <forgot-password-form
                v-if="showMessage===false"
                :errors="authErrors"
                :loading="loading"
                @submit="onSubmit"
            />
            <p class="orangetext" v-else>
                {{ showMessage }}
            </p>
        </div>
    </div>
</template>

<script>
import ForgotPasswordForm from './ForgotPasswordForm'
import userApi from '../api'

export default {
    name: 'Forgot',
    components: {ForgotPasswordForm},
    data() {
        return {
            authErrors: {},
            loading: false,
            showMessage: false
        }
    },
    mounted: function () {
        if (this.$auth.user()) {
            this.redirectLogin();
        }
    },
    methods: {
        onSubmit(forgotPasswordData) {
            this.loading = true
            userApi.forgotPassword({'award': this.currentAward, ...forgotPasswordData}).then(r => {
                if (r && r.data && r.data.status) {
                    this.showMessage = r.data.status;
                } else {
                    this.$message.error('Please make sure you have created an account with that e-mail and try again.');
                }
            }).catch((err) => {
                this.$message.error('Please make sure you have created an account with that e-mail and try again.');
            }).finally(() => {
                this.loading = false;
            })
        }
    }
}
</script>

<style scoped lang="scss">

</style>
